import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4 rounded w-[50%] md:w-[25%] mx-auto p-1 bg-gray-300 dark:bg-gray-800 animate-pulse" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tippy = _resolveComponent("Tippy")!
  const _component_Premium = _resolveComponent("Premium")!

  return (_ctx.user)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: "truncate text-lg space-x-2",
        style: _normalizeStyle(_ctx.getPremiumStyle)
      }, [
        _createVNode(_component_Tippy, {
          content: _ctx.displayName ? '@' + _ctx.user.username : _ctx.user?.display_name
        }, {
          default: _withCtx(() => [
            _createTextVNode(" @" + _toDisplayString(_ctx.displayName ? _ctx.user?.display_name : _ctx.user.username), 1)
          ]),
          _: 1
        }, 8, ["content"]),
        (_ctx.user?.is_premium)
          ? (_openBlock(), _createBlock(_component_Tippy, {
              key: 0,
              content: "Premium subscriber"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Premium, { class: "text-primary-300" })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ], 4))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}